// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".autocomplete__selection-max-height[data-v-614f8208]  .v-select__selections{margin:5px 0 7px;overflow-y:auto;max-height:100px}.autocomplete__link[data-v-614f8208]{font-size:13px;padding:0 16px 3px;width:100%}.autocomplete__chip-text[data-v-614f8208]{max-width:100%;text-overflow:ellipsis;overflow:hidden}.v-list-item__content--append[data-v-614f8208]{flex-wrap:nowrap;justify-content:space-between;grid-gap:20px;gap:20px}.v-list-item__content--append *[data-v-614f8208]{flex:none}", ""]);
// Exports
module.exports = exports;
